import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 19 19",
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M12.4448 12.4449C15.2969 12.063 17.4967 9.62009 17.4967 6.66341C17.4967 3.44175 14.885 0.830078 11.6633 0.830078C8.70664 0.830078 6.26373 3.0298 5.88188 5.88197M5.41332 9.99674L6.66332 9.16341V13.7467M5.41332 13.7467H7.91332M12.4967 11.6634C12.4967 14.8851 9.88498 17.4967 6.66332 17.4967C3.44166 17.4967 0.829987 14.8851 0.829987 11.6634C0.829987 8.44175 3.44166 5.83008 6.66332 5.83008C9.88498 5.83008 12.4967 8.44175 12.4967 11.6634Z",
    stroke: $props.color,
    "stroke-width": "1.66",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}